/* RESPONSIBLE TEAM: team-proactive-support */
export const statsTab = {
  overview: 'content',
  entered: 'receipts',
  completed: 'seriesCompletions',
};

export const defaultDelayDescription = '30d';
